import React from 'react';
import TextField from '@mui/material/TextField';

export default function PhoneField({ name, value, handleChange }) {
  const formatTelefone = (val) => {
    let v = val.replace(/\D/g, ''); // remove tudo que não é número
    if (v.length > 11) v = v.slice(0, 11); // limita a 11 dígitos
    if (v.length > 6) return v.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
    if (v.length > 2) return v.replace(/(\d{2})(\d{0,5})/, '($1) $2');
    if (v.length > 0) return v.replace(/(\d{0,2})/, '($1');
    return v;
  };

  const onChange = (e) => {
    const formatted = formatTelefone(e.target.value);
    handleChange({ target: { name, value: formatted } });
  };

  return (
    <TextField
      label="Telefone"
      name={name}
      variant="outlined"
      value={value}
      onChange={onChange}
      fullWidth
      slotProps={{ maxLength: 15 }} // garante tamanho máximo
    />
  );
}
